import { JSX } from "react";
import { Image } from "@sitecore-content-sdk/nextjs";
import { VisualDividerProps } from "components/visual-divider/visual-divider.props";
import { extractHiddenBlock } from "../../utils/styles";
import { NoDataFallback } from "../../utils/NoDataFallback";

export const Default = (props: VisualDividerProps): JSX.Element => {
  console.log("---->[VisualDivider] Component", props.fields);

  const { fields, params } = props;

  if (!fields?.BackgroundImage) {
    return <NoDataFallback componentName="Visual Divider" />;
  }

  const hiddenBlockStyles = extractHiddenBlock(params?.GridParameters);

  return (
    <div
      className={`visualdivider-component w-full relative bg-cover bg-center bg-no-repeat ${hiddenBlockStyles}`}
      data-testid="visual-divider"
      data-role="visual-divider-component"
    >
      <Image
        field={fields.BackgroundImage}
        className="w-full"
        imageParams={{ mw: 1200 }}
        data-testid="visual-divider-image"
      />
    </div>
  );
};
